import each from "lodash/each";
import filter from "lodash/filter";
import find from "lodash/find";
import findIndex from "lodash/findIndex";
import isUndefined from "lodash/isUndefined";
import range from "lodash/range";
import uniq from "lodash/uniq";
import without from "lodash/without";

export const MixinTimeline = {
  computed: {
    timelineMarkers() {
      // Two things here.
      // 1. Filter so that only markers within the space are returned.
      // 2. Apply the appropriate level of scale (1, 2, 3, 4, or 15, 30, 45 etc.)
      var duration = this.show.data.audio.duration;
      var additional_preroll_margin_percent = 1;
      var additional_postroll_margin_percent = 0;
      var startWindowTime =
        ((this.timelineWindowInPercent - additional_preroll_margin_percent) /
          100) *
        duration;
      var endWindowTime =
        ((this.timelineWindowOutPercent + additional_postroll_margin_percent) /
          100) *
        duration;
      var timespanDuration = endWindowTime - startWindowTime;
      var markSpacingPixels = this.componentWidth / timespanDuration;
      var spanInterval = Math.round(60 * (2 / markSpacingPixels));
      var acceptable_spans = [
        1,
        5,
        15,
        30,
        60,
        60 * 2,
        60 * 3,
        60 * 5,
        60 * 10
      ];

      spanInterval = find(acceptable_spans, i => {
        return i >= spanInterval;
      });

      if (isUndefined(spanInterval)) {
        spanInterval = 1;
      }

      var marks = filter(
        range(Math.floor(startWindowTime), Math.floor(endWindowTime)),
        i => !(i % spanInterval)
      );

      return marks;
    },
    timelineWindowInPercent() {
      return (-this.timelineLeft / this.timelineWidth) * 100;
    },
    timelineWindowOutPercent() {
      return (
        (-(this.timelineLeft - this.componentWidth) / this.timelineWidth) * 100
      );
    }
  },
  methods: {
    timelineDragged(obj) {
      if (obj.first || obj.last) {
        if (obj.last) {
          // If the last is triggered without any dragging taken place, gotoAndPlay or gotoAndPause.
          if (!this.timelineDragging) {
            var parentX = obj.el.getBoundingClientRect().left;
            var time =
              ((obj.clientX - parentX) / this.timelineWidth) *
              this.show.data.audio.duration;
            if (this.player_ref.audio_ref.paused) {
              this.player_ref.gotoAndPause(time);
            } else {
              this.player_ref.gotoAndPlay(time);
            }
          }
        }
        this.timelineDragging = false;
        return;
      } else {
        // This is a drag, move that timeline!
        var newLeft = this.timelineLeft + obj.deltaX;
        this.setTimelineLeft(newLeft);
        this.timelineDragging = true;
        //console.log(obj);
      }
    },
    onSlideDragged(obj, slide, idx) {
      if (obj.first) {
        this.dragStartX = obj.clientX - obj.el.getBoundingClientRect().left;
        console.log(obj);
        this.lastSlideEventType = "click";
        this.setClickedTimelineItem({ type: "slide", id: slide.id });
      }
      if ("offsetX" in obj) {
        var secPerPixel = this.show.data.audio.duration / this.timelineWidth;
        var parentX = this.$refs.timeline.getBoundingClientRect().left;
        var newTime = (obj.clientX - parentX - this.dragStartX) * secPerPixel;
        //console.log(`Move slide ${slide.id} completely ${newTime} seconds.`);
        if (newTime < 0) {
          newTime = 0;
        }
        var updateObj = {
          image_id: slide.id,
          time: newTime,
          sortAtEnd: true
        };
        if (!this.groupedSlideIds.includes(slide.id)) {
          // When dragging, the id always has to be in the group.
          console.log(idx);
          this.setSlideGroup(slide.id, obj.evt);
          //this.groupedSlideIds.push(slide.id);
          //this.$store.commit("show/setGroupedSlideIds", this.groupedSlideIds);
        }

        this.$store.dispatch("slides/updateImageByIdToTime", updateObj);
        this.lastSlideEventType = "drag";
      }
      if (obj.last) {
        console.log(this.lastSlideEventType);
        if (this.lastSlideEventType != "drag") {
          this.setSlideGroup(slide.id, obj.evt);
        }
        this.$emit("refreshPlayer");
      }
    },
    setSlideGroup(slideId, $event) {
      console.log(
        "setSlideGroup",
        slideId,
        $event.shiftKey,
        $event.metaKey,
        $event.ctrlKey
      );
      var slideArray = this.show.data.slideArray || [];
      var saveLastSelected = true;

      if (!$event.shiftKey && !$event.metaKey && !$event.ctrlKey) {
        // No modifier keys down, just reset groupedSlideIds;
        this.groupedSlideIds = [slideId];
        this.groupedOverlayIds = []; // Clear the overlay ids in this case.
      } else {
        // We've got a key modifier, let's see what we can do.
        // Single slide toggle modifier.
        if ($event.metaKey || $event.ctrlKey) {
          // Add to existing groupedSlides.
          if (this.groupedSlideIds.includes(slideId)) {
            this.groupedSlideIds = without(this.groupedSlideIds, slideId);
            saveLastSelected = false;
          } else {
            this.groupedSlideIds.push(slideId);
          }
        }

        // Group modifier.
        if ($event.shiftKey) {
          // Toggle the slide as normal.
          if (this.groupedSlideIds.includes(slideId)) {
            this.groupedSlideIds = without(this.groupedSlideIds, slideId);
            saveLastSelected = false;
          } else {
            this.groupedSlideIds.push(slideId);
          }
          // Then select all items from the closest selected to this slideId.
          if (this.lastSlideIdSelected) {
            var indexOfLastSelected = findIndex(slideArray, {
              id: this.lastSlideIdSelected
            });
            var indexOfSelected = findIndex(slideArray, {
              id: slideId
            });
            if (indexOfLastSelected > -1) {
              each(range(indexOfLastSelected, indexOfSelected), n => {
                var _id = slideArray[n].id;
                this.groupedSlideIds.push(_id);
              });
              this.groupedSlideIds = uniq(this.groupedSlideIds);
            }
          }
        }
      }

      if (saveLastSelected) {
        this.lastSlideIdSelected = slideId;
      } else {
        this.lastSlideIdSelected = null;
      }

      console.log("groupedSlideIds", this.groupedSlideIds);
      this.$store.dispatch(
        "show/updateGroupedOverlayIds",
        this.groupedOverlayIds,
        {
          root: true
        }
      );
      this.$store.dispatch("show/updateGroupedSlideIds", this.groupedSlideIds, {
        root: true
      });
    },
    imageStyle(idx) {
      //console.log(this.slideWidthPx(idx));
      return {
        width: "auto",
        height: this.slideHeight - 2 + "px",
        "max-height": this.slideHeight - 2 + "px",
        "max-width": this.slideWidthPx(idx) + "px"
      };
    },
    isSlideOnScreen(slide, idx) {
      var left =
        (slide.timing / (this.show.data.audio.duration * 1000)) *
        this.timelineWidth;

      var actualLeft = this.timelineLeft + left + this.componentLeft;

      var additional_margin_px = 10;

      return !(
        actualLeft + this.slideWidthPx(idx) + additional_margin_px >=
          this.componentLeft &&
        actualLeft <=
          this.componentRight + this.slideWidthPx(idx) + additional_margin_px
      );
    },
    slideStyle(slide, idx) {
      return {
        width: this.slideWidthPx(idx) + "px",
        top: this.slidesTopPx + "px",
        left:
          (slide.timing / (this.show.data.audio.duration * 1000)) *
            this.timelineWidth +
          "px"
      };
    }
  }
};
